var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 294.973,
    height: 70,
    viewBox: "0 0 294.973 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_90",
    "data-name": "\\uC0AC\\uAC01\\uD615 90",
    width: 294.973,
    height: 70,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blue.svg",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_89",
    "data-name": "\\uC0AC\\uAC01\\uD615 89",
    width: 294.973,
    height: 70,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_124",
    "data-name": "\\uADF8\\uB8F9 124",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_123",
    "data-name": "\\uADF8\\uB8F9 123",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_272",
    "data-name": "\\uD328\\uC2A4 272",
    d: "M21.552,1.312H59.878C75.5,1.312,83.4,7.776,83.4,17.43c0,7.193-4.22,11.929-9.965,14.114C80.795,34,86.088,39.648,86.088,48.39c0,10.654-7.987,18.03-24.146,18.03H21.552ZM57.008,26.354c4.13,0,6.462-1.82,6.462-4.734,0-2.825-2.332-4.372-6.372-4.372H42.645v9.106Zm.987,23.4c4.756,0,7.539-1.641,7.539-5.191,0-3.006-2.064-5.008-7.269-5.008H42.645v10.2Z",
    transform: "translate(18.057 1.135)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_273",
    "data-name": "\\uD328\\uC2A4 273",
    d: "M59.207,1.312H80.48V47.48h31.146V66.419H59.207Z",
    transform: "translate(49.606 1.134)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_274",
    "data-name": "\\uD328\\uC2A4 274",
    d: "M90.171,39.648V1.312h21.273V38.1c0,7.648,4.13,11.927,11.937,11.927s11.939-4.279,11.939-11.927V1.312h21.275V39.193c0,14.662-6.284,28.957-33.392,28.957-26.926,0-33.031-14.114-33.031-28.5",
    transform: "translate(75.549 1.135)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_275",
    "data-name": "\\uD328\\uC2A4 275",
    d: "M186.115,19.16V1.312H129.927V66.419h56.188V48.571H151.2V41.7h31.431V26.035H151.2V19.16Z",
    transform: "translate(108.858 1.134)",
    fill: "#1a1818"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.57ef7fd014eadf48fca6a79adf115513.svg";
export { ForwardRef as ReactComponent };